'use client';

import { useEffect, useState } from 'react';

import { TurnstileModal } from '@/components/TurnstileModal';
import {
  DEFAULT_TURNSTILE_CONFIG,
  TURNSTILE_EVENT_MODAL_TRIGGER,
} from '@/modules/turnstile/constants';

export function TurnstileProvider() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  function openModal() {
    setIsModalOpen(true);
  }

  useEffect(() => {
    document.addEventListener(TURNSTILE_EVENT_MODAL_TRIGGER, openModal);

    return () => {
      document.removeEventListener(TURNSTILE_EVENT_MODAL_TRIGGER, openModal);
    };
  }, []);

  return (
    <TurnstileModal
      isOpen={isModalOpen}
      onCloseAction={() => setIsModalOpen(false)}
      siteKey={DEFAULT_TURNSTILE_CONFIG.siteKey}
    />
  );
}
